/**
 * @internal
 */
export const packageVersion = '23.6.0';
//# sourceMappingURL=version.js.map